module.exports = __webpack_public_path__ + "static/media/new_chrome.442a3695.svg";